<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("wms.menu.product") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<div class="row">
							<div class="col-lg-12">
							<h2>Platform : {{ this.$route.params.platform}}</h2>
							</div>
						</div>
						<div class="row">

                        <div class="col-lg-3">
                            <base-input
                                v-model="keyword"
                                prepend-icon="fas fa-search"
                                :placeholder="$t('search')"
                            >
                            </base-input>
                        </div>

						 <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="productStatus"
                                        :placeholder="$t('status')"
                                    >
                                        <el-option
											v-for="option in StatusTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

						<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="map_sku_type"
                                        :placeholder="$t('status')"
                                    >
                                        <el-option
											v-for="option in MapSkuTypeTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

						<div class="col-md-2">
								<base-button
                                        @click.native="handleSearch()"
                                        class="edit"
                                        type="warning"
                                        size="md"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-search"></i>
                                    </base-button>
						</div>
						</div>
		



						
                    </template>

                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >

							<el-table-column >
									<div slot-scope="{  row }" class="d-flex">
										<img :src="GetProductUrl(row.images)" height="100px" v-if="row.images.includes('.png') || row.images.includes('.jpg') || row.images.includes('jpeg') || row.images.includes('http')"/>
									</div>
							</el-table-column>

							<el-table-column label="Shop" >
								<div slot-scope="{  row }" >
									{{ row.platform_shop_name}}
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('name')" >
								<div slot-scope="{  row }" >
									{{ row.name}}
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('code')" >
								<div slot-scope="{  row }" >
									{{ row.code}}
								</div>
                            </el-table-column>

							<el-table-column :label="$t('shipping_cost')" >
								<div slot-scope="{  row }" >
									{{ row.shipping_cost}}
								</div>
                            </el-table-column>

                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="handleEdit($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash  text-white"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('name')" v-model="params.name"> </base-input>

                <base-input :label="$t('description')" v-model="params.detail">
                </base-input>


                <input type="hidden" class="new-event--start" />
                <input type="hidden" class="new-event--end" />
            </form>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "Product/getData",
            getPlatformCurrentParams: "Product/getPlatformCurrentParams"
        }),
        tableData: function() {
            if (this.productStatus != 0 || this.keyword != "") {
              return this.tableDataOrg.filter((m)=>{
				let c1 = true
				let c2 = true
				if (this.productStatus != 0) {
					c1 = m.status == this.productStatus
				} 

				if (this.keyword != ""){
					c2 = m.name.includes(this.keyword)
				}

                return c1 && c2
              });
            }
            return this.tableDataOrg;
        },
		searchParams:function(){
			return {
				platform_id: this.GetPlatfromID(this.$route.params.platform),
				map_sku_type: this.map_sku_type
			}
		}
       
    },
    data() {
        return {
            propsToSearch: ["name"],
            selectedRows: [],
            showAddModal: false,
			map_sku_type: 2,
			keyword: "",
            params: {
                id: 0,
                name: "",
                detail: "",
                price: "",
                cod: "",
                code: "",
				atrributes:"",
				tag:"",
				status:1,
				product_sku:"",
            },
			productStatus:0,
			StatusTable : [
				{id:0,name:"ทั้งหมด"},
				{id:1,name:"ใช้งาน"},
				{id:2,name:"ไม่ใช้งาน"},
			],
			MapSkuTypeTable : [
				{id:0,name:"ทั้งหมด"},
				{id:1,name:"ผูกคลังสินค้าแล้ว"},
				{id:2,name:"ยังไม่ได้ผูกคลังสินค้า"},
			],
			PlatformTable: [
				{id:1,name:"madamefin"},
				{id:2,name:"tiktok"},
				{id:3,name:"shopee"},
				{id:4,name:"lazada"},
				{id:5,name:"line"},
				{id:8,name:"pancake"},

			]
        };
    },
    mounted() {
		let documentClasses = document.body.classList;
		documentClasses.remove("modal-open");
		console.log(this.$route.params)
        this.listData(this.searchParams);
		this.getParam()
    },
    methods: {
        ...mapActions({
            createData: "Product/createData",
            updateData: "Product/updateData",
            deleteData: "Product/deleteData",
            listData: "Product/listData",
			setPlatformCurrentParams : "Product/setPlatformCurrentParams"
        }),
		setParam(){
			this.setPlatformCurrentParams({
				mappingStatus: this.map_sku_type,
				status : this.productStatus,
				currentPage: this.pagination.currentPage
			})
		},
		getParam(){
			this.map_sku_type = this.getPlatformCurrentParams.mappingStatus
			this.productStatus = this.getPlatformCurrentParams.status
			this.pagination.currentPage = this.getPlatformCurrentParams.currentPage
		},
		handleSearch(){
			this.setParam()
			this.listData(this.searchParams);
			this.getParam()
		},
		GetPlatfromID(platform) {
			let platform_id = 0
			this.PlatformTable.forEach(v=>{
					console.log(v.name)
				if (v.name == platform)
				{
					platform_id = v.id
				}
			})

			return platform_id
		},
        handleCreate() {
			this.$router.push({ name: "product_form" });
            
        },
        handleEdit(index, row) {
			this.setParam()
			this.$router.push({ name: "platform_product_form" ,params:{params:row,platform:this.$route.params.platform,id:row.id}});
        },
        handleUpdate() {
            this.showAddModal = false;
            // Create

            if (this.params.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        this.listData(this.searchParams);
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
                // Update
                this.updateData({id:this.params.id,payload:this.params})
                    .then(resp => {
                        this.listData(this.searchParams);
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {
			this.setParam()
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.id)
                        .then(resp => {
                            this.listData(this.searchParams);
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            } else {
            }
            this.params.files = files[0];
        },
		GetProductUrl(filename){
			if (filename.includes("http")){
				return filename
			}
			return process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
